// extracted by mini-css-extract-plugin
export default {"node-label":"SystemArchitecture_node-label__kNvvj","port-label":"SystemArchitecture_port-label__M9957"};